<template>
  <div class="my-12 py-12">
    <v-carousel cycle hide-delimiters show-arrows-on-hover>
      <v-carousel-item v-for="step in steps" :key="step.id">
        <v-card light flat height="500">
          <v-card-title class="d-flex align-start flex-column">
            <span class="caption">{{ step.who }}</span>
            <span>{{ step.title }}</span>
          </v-card-title>
          <v-img :src="require(`../assets/${step.image}`)" height="300px" />

          <v-card-text>{{ step.description }}</v-card-text>
        </v-card>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
export default {
  name: "OverviewDesktop",
  props: ["steps"],
};
</script>
